// :: Dependencies
import {
  auth,
  firestore,
  database,
  timestampDatabase
} from "@/config/firebase";
import {
  USER_SAVE,
  USER_LOGIN,
  USER_VIDEO_TUTORIAL,
  USER_LOGOUT,
  USER_NAME_SAVE,
  USER_CONECTION,
  USER_BRANCH_SAVE
} from "./mutation-types";
import { errorMessage, showMessage } from "@/services/MessageService";
import { loaderDone, loaderStart } from "@/services/LoaderService";
import router from "@/config/router";
import moment from "moment";

export default {
  // :: passwordEmailAction
  // :: Signs a user with email and password
  // :: https://firebase.google.com/docs/reference/js/firebase.auth.Auth#signinwithemailandpassword
  async passwordEmailAction({ commit, dispatch }, data) {
    loaderStart();
    try {
      const { email, password } = data;
      const user = await auth.signInWithEmailAndPassword(email, password);
      const userData = await firestore("users")
        .where("uid", "==", user.user.uid)
        .get();
      const userAccess = userData.docs[0].data().userAccess;
      const branch = userData.docs[0].data().branch;
      commit(USER_SAVE, { user: user.user, access: userAccess });
      commit(USER_LOGIN);
      const name = await dispatch("getNameUser", user.user.uid);
      commit(USER_NAME_SAVE, name);
      commit(USER_BRANCH_SAVE, branch);
      dispatch("connectedUserAnalyctis");
    } catch (error) {
      console.error(":: Error login with password - ", error);
      //TODO: change this with global error files or with i18n
      switch (error.code) {
        case "auth/user-not-found":
          errorMessage("Verifica que los datos sean validos");
          break;
        case "auth/invalid-email":
          errorMessage("Correo no valido");
          break;
        case "auth/user-disabled":
          errorMessage("Usuario no habilitado, contacta al administrador");
          break;
        case "auth/wrong-password":
          errorMessage("Usuario o password no validos");
          break;
      }
    } finally {
      loaderDone();
    }
  },
  async getNameUser(_, uid) {
    try {
      if (uid) {
        const userData = await firestore("users")
          .doc(uid)
          .get();
        if (userData.exists) return userData.data().name;
        else return "";
      } else return "";
    } catch (error) {
      errorMessage("Error al obtener información del usuario");
    }
  },
  // :: singOut
  // :: Performs user logout
  // :: https://firebase.google.com/docs/reference/js/firebase.auth.Auth#sign-out
  async singOut({ commit }) {
    try {
      await auth.signOut();
      commit(USER_LOGOUT);
      router.push({ name: "login" });
    } catch (error) {
      console.error(":: Error logout - ", error);
      errorMessage(error);
    }
  },
  connectedUserAnalyctis({ state, getters }) {
    if (!getters.isLogged) return;
    database(".info/connected").on("value", function(snapshot) {
      if (snapshot.val() === true) {
        const timeLog = moment().unix();
        const spendConnectedGlobalRef = database(
          `usersTimeLogs/global/${timeLog}`
        );
        const lastConnectedRef = database(
          `usersTimeLogs/byUser/${state.data.uid}/last_connected`
        );
        lastConnectedRef.set({
          connected: timestampDatabase,
          uid: state.data.uid,
          created: moment().format()
        });
        lastConnectedRef.onDisconnect().update({
          disconnected: timestampDatabase
        });
        spendConnectedGlobalRef.set({
          connected: timestampDatabase,
          uid: state.data.uid,
          created: moment().format()
        });
        spendConnectedGlobalRef.onDisconnect().update({
          disconnected: timestampDatabase
        });
      }
    });
  },
  userOnlineStatus({ commit }) {
    database(".info/connected").on("value", function(snapshot) {
      if (snapshot.val() === true) commit(USER_CONECTION, false);
      else commit(USER_CONECTION, true);
    });
  },
  changeVideoTutorial({ commit }, status) {
    commit(USER_VIDEO_TUTORIAL, status);
  },
  updatesLogs({ state }, ref) {
    try {
      const timeLog = moment().unix();
      database(`updatesLogs/global/${timeLog}`).set({
        created: moment().format(),
        uid: state.data.uid,
        ref
      });
    } catch (error) {
      console.log(error);
    }
  },
  async sendPasswordResetEmail(_, email) {
    try {
      await auth.sendPasswordResetEmail(email);
      showMessage({
        message: "Se envío el correo de recuperación",
        color: "success"
      });
    } catch (error) {
      errorMessage("Error recuperar la contraseña " + error.code);
    }
  }
};
